<template>
  <b-nav class="ml-4">
    <b-nav-item>
      <router-link :to="{ path: `/unit/management` }">
        <b-button :class="{ 'esep-blue-bg': activeTab != 'UNIT' }" variant="primary">{{ $t("unit.management") }}</b-button>
      </router-link>
    </b-nav-item>
    <b-nav-item>
      <router-link :to="{ path: `/billing-method/management` }">
        <b-button :class="{ 'esep-blue-bg': activeTab != 'BILLING_METHOD' }" variant="primary">{{ $t("billingMethod.management") }}</b-button>
      </router-link>
    </b-nav-item>
  </b-nav>
</template>

<script>
export default {
  computed: {
    activeTab() {
      let activeTab = "";
      if (this.$route.name == "billingMethodManagement") {
        activeTab = "BILLING_METHOD";
      } else if (this.$route.name == "unitManagement") {
        activeTab = "UNIT";
      } else {
        activeTab = "UNIT_ADD"
      }
      return activeTab;
    },
  },
};
</script>
